import { useAuth } from "@clerk/clerk-react";
import { useMemo } from "react";

import { ApiClient } from "./api";

// useApi returns an ApiClient bound to the current Clerk session's getToken.
// Components call e.g. `const api = useApi(); api.get("/me")`.
export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => new ApiClient((opts) => getToken(opts)), [getToken]);
}
